<template>
    <l-map ref="map"
           :zoom="zoom"
           :center="center"
           :options="this.mapOptions"
           @ready="initMap()">
    </l-map>
</template>

<script>
import L from 'leaflet';
import { mapState } from 'vuex';
import ApiService from "../APIService";
import Vue from "vue";

L.Map.prototype.panToOffset = function(latlng, offset, options, keepZoom) {
    let x = this.latLngToContainerPoint(latlng).x - offset[0];
    let y = this.latLngToContainerPoint(latlng).y - offset[1];
    let point = this.containerPointToLatLng([x, y]);
    if (keepZoom) {
        return this.flyTo(point, this._zoom, { pan: options });
    } else {
        return this.flyTo(point, 15, { pan: options });
    }
};

let tooltipAnchor = [10, 0];
let isCordovaApp = !!window.cordova;

export default {
    name: 'Main',
    data() {
        return {
            map: null,
            mapOptions: {
                zoomControl: false,
                attributionControl: false,
                fadeAnimation: false,
                preferCanvas: true
            },
            zoom: 9,
            center: [46.1344841, 14.7546136],
            icons: {
                device: [L.icon({
                    iconUrl: 'img/device_01.png',
                    iconSize: [18, 18],
                    tooltipAnchor: tooltipAnchor
                }),
                L.icon({
                    iconUrl: 'img/device_02.png',
                    iconSize: [18, 18],
                    tooltipAnchor: tooltipAnchor
                }),
                L.icon({
                    iconUrl: 'img/device_03.png',
                    iconSize: [18, 18],
                    tooltipAnchor: tooltipAnchor
                }),
                L.icon({
                    iconUrl: 'img/device_10.png',
                    iconSize: [24, 24],
                    tooltipAnchor: tooltipAnchor
                })]
            },
            mapIsMovingProgrammatically: false // to distinguish programmatic and human map interaction
        };
    },
    mounted() {
        // this.map.on('movestart', this.followOff) // stop following upon user interaction
        if (!isCordovaApp) {
            this.getUserDataFromApiAndLogoutIfNecessary();
        }
        else {
            document.addEventListener('deviceready', () => {
                this.getUserDataFromApiAndLogoutIfNecessary().then(response => {
                    WonderPush.subscribeToNotifications(false, function() {
                        WonderPush.setUserId(response.uuid);
                    });
                });
            }, false);

            document.addEventListener("resume", function () {
                //nothing for now...
            }, false);
        }
    },
    methods: {
        initMap() {
            // Initialize map and save it to the store, so that other components can use it too.
            this.map = this.$refs.map.mapObject;
            this.$store.dispatch('map/map', this.map);

            this.tileLayers = [];
            for (let provider of this.tileProviders) {
                let layer = L.tileLayer(provider.url);
                this.tileLayers.push(layer);
            }
            this.reloadTiles();

            this.reloadMarkers();
        },
        markerClick(device) {
            this.$store.dispatch('devicePanelOpen', true);
            this.$store.dispatch('selectDevice', device);
        },
        reloadTiles() {
            for (let [l, layer] of this.tileLayers.entries()) {
                if (this.tileProviders[l].visible) {
                    layer.addTo(this.map);
                } else {
                    this.map.removeLayer(layer);
                }
            }
        },
        reloadMarkers() {
            this.$store.dispatch('map/clearLayerGroupLayers', 'markers');

            // Hide markers on history tab, we are on history tab, if history sessions are visible.
            // Don't hide if it is today's date.
            let isHistorySameDay = this.$moment(this.$store.state.map.historyEndDate).isSame(this.$moment(), 'days');
            if (isHistorySameDay || this.$store.state.map.historySessions.length <= 0) {
                for (let device of this.$store.state.data.devices) {
                    if (!this.selectedDevice.id || !this.showIsolated || device.id === this.selectedDevice.id) {
                        let marker = L.marker(device.position, {
                            icon: this.icons.device[device.state],
                            zIndexOffset: device.id === this.selectedDevice.id ? 1000 : 0
                        });
                        marker.on('click', this.markerClick.bind(null, device));
                        let selected = this.selectedDevice.id === device.id ? ' selected' : '';
                        marker.bindTooltip(device.label, {
                            permanent: this.$store.state.map.showLabels,
                            interactive: true,
                            direction: 'right',
                            className: 'map-device-tooltip group' + device.group + selected
                        });
                        this.$store.dispatch('map/addLayerToGroup', ['markers', marker]);
                    }
                }
            }

            if (this.followDevice.position) {
                let margin = 100 / (2 ** (this.map.getZoom() + 1));
                if (this.selectedDevice.position[1] > this.map.getBounds().getEast() - margin ||
                    this.selectedDevice.position[1] < this.map.getBounds().getWest() + margin ||
                    this.selectedDevice.position[0] > this.map.getBounds().getNorth() - margin ||
                    this.selectedDevice.position[0] < this.map.getBounds().getSouth() + margin) {
                    this.panToOffsetWrapper(this.selectedDevice.position, 1);
                }
            }
            if (this.meLayer) {
                this.meLayer.clearLayers();
            }
            if (this.$store.state.map.showMe) {
                let marker = L.marker(this.myLocation, { icon: this.icons.device[3], zIndexOffset: 1000 });
                marker.bindTooltip(this.$t("you"));
                this.$store.dispatch('map/addLayerToGroup', ['markers', marker]);
            }
        },
        askUserToOpenLocationSettings(locationEnabled){
            if (!locationEnabled && confirm(this.$t('want_to_enable_location'))) {
                cordova.plugins.diagnostic.switchToLocationSettings()
            }
        },
        checkIfLocationIsOn(){
            if (!navigator.geolocation || !isCordovaApp) return;
            cordova.plugins.diagnostic.isLocationEnabled(this.askUserToOpenLocationSettings, this.askUserToOpenLocationSettings);
        },
        reloadMe() {
            if (this.$store.state.map.showMe) {
                if (navigator.geolocation) {

                    if (!this.location_watcher) {
                        // navigator.geolocation.watchPosition(this.showPosition, this.noPosition, { maximumAge: 3600, timeout: 5000, enableHighAccuracy: false })

                        navigator.geolocation.getCurrentPosition(this.showPosition, this.noPosition, {
                            maximumAge: 10000,
                            timeout: 5000,
                            enableHighAccuracy: true
                        });
                    }
                } else {
                    alert('Geolocation is not supported by this browser.');
                }
            } else {
                this.myLocation = null;
                this.reloadMarkers();
            }
        },
        followOff() {
            if (this.followDevice && !this.mapIsMovingProgrammatically) {
                this.$store.commit('map/followDevice', -1);
            }
        },
        showPosition(position) {
            let focus = false;
            if (!this.myLocation) focus = true;
            this.myLocation = [position.coords.latitude, position.coords.longitude];
            if (focus) this.panToOffsetWrapper([position.coords.latitude, position.coords.longitude]);
            this.reloadMarkers();
        },
        noPosition(err) {
            // alert('Unable to obtain position.')
            console.log(err);
        },
        panToOffsetWrapper(latlng, keepZoom) {
            this.mapIsMovingProgrammatically = true;
            this.map.panToOffset(latlng, [0, -3], null, keepZoom);
            this.mapIsMovingProgrammatically = false;
        },
        getUserDataFromApiAndLogoutIfNecessary() {
            if (!this.api) this.api = new ApiService();
            return this.api.getUserData()
                .then(response => {
                    if (response.isActive !== 1) {
                        this.logoutWonderPush();
                        this.$store.dispatch('logout');
                        throw new Error('unknown');
                    }
                    else return response;
                })
                .catch(error => {
                    if (error.response && error.response.data.error === 'Unauthorized') {
                        this.logoutWonderPush();
                        this.$store.dispatch('logout');
                    }
                    throw error;
                });
        },
        logoutWonderPush(){
            if (isCordovaApp) {
                WonderPush.clearAllData();
            }
        }
    },
    computed: {
        ...mapState({
            historySessions: state => state.historySessions,
            selectedDeviceIndex: state => state.ui.selectedDeviceIndex,
            showMe: state => state.map.showMe,
            showIsolated: state => state.map.showIsolated,
            showLabels: state => state.map.showLabels,
            followDevice: state => state.map.followDevice,
            tileProviders: state => state.map.tileProviders,
            reloadMarkersWatcher: state => state.map.reloadMarkersWatcher,
            markersLayer: state => state.map.markersLayer,
            devices: state => state.data.devices
        }),
        selectedDevice: function() {
            return this.$store.getters.selectedDevice;
        }
    },
    watch: {
        'showLabels': function() {
            this.reloadMarkers();
        },
        'showMe': function() {
            this.checkIfLocationIsOn();
            this.reloadMe();
        },
        'showIsolated': function() {
            this.reloadMarkers();
        },
        'reloadMarkersWatcher': function() {
            this.reloadMarkers();
        },
        'followDevice': function(device) {
            if (this.followDevice.position) {
                this.panToOffsetWrapper(device.position);
            }
        },
        'selectedDeviceIndex': function(device) {
            this.reloadMarkers();
            if (this.selectedDevice.position) {
                this.panToOffsetWrapper(this.devices[device].position);
            }
        },
        'devices': {
            handler() {
                this.reloadMe();
            },
            deep: true
        },
        'tileProviders': {
            handler() {
                this.reloadTiles();
            },
            deep: true
        }
    }
};
</script>

<style lang="scss">
    .map {
        height: 100%;
        margin: 0;
    }

    .leaflet-tooltip.map-device-tooltip {
        border-radius: 0;
        padding: 0.1em 0.5em;
        border: none;

        &.selected {
            z-index: 100;
            font-weight: bolder;
        }
    }

    .leaflet-tooltip-left.map-device-tooltip:before,
    .leaflet-tooltip-right.map-device-tooltip:before {
        margin-top: -10px;
    }

    .leaflet-tooltip-top.map-device-tooltip:before,
    .leaflet-tooltip-bottom.map-device-tooltip:before,
    .leaflet-tooltip-left.map-device-tooltip:before,
    .leaflet-tooltip-right.map-device-tooltip:before {
        border: 10px solid transparent;
    }

    .leaflet-tooltip-right.map-device-tooltip:before {
        border-right-color: #fff;
        margin-left: -20px;
    }

    .leaflet-tooltip-left.map-device-tooltip:before {
        margin-right: -20px;
        border-left-color: #fff;
    }

    .leaflet-tooltip-right {
        &.group1 {
            box-shadow: 5px 0 0 $group1;
        }

        &.group2 {
            box-shadow: 5px 0 0 $group2;
        }

        &.group3 {
            box-shadow: 5px 0 0 $group3;
        }

        &.group4 {
            box-shadow: 5px 0 0 $group4;
        }

        &.group5 {
            box-shadow: 5px 0 0 $group5;
        }

        &.group6 {
            box-shadow: 5px 0 0 $group6;
        }

        &.group7 {
            box-shadow: 5px 0 0 $group7;
        }

        &.group8 {
            box-shadow: 5px 0 0 $group8;
        }

        &.group9 {
            box-shadow: 5px 0 0 $group9;
        }
    }

    .leaflet-tooltip-left {
        &.group1 {
            box-shadow: -5px 0 0 $group1;
        }

        &.group2 {
            box-shadow: -5px 0 0 $group2;
        }

        &.group3 {
            box-shadow: -5px 0 0 $group3;
        }

        &.group4 {
            box-shadow: -5px 0 0 $group4;
        }

        &.group5 {
            box-shadow: -5px 0 0 $group5;
        }

        &.group6 {
            box-shadow: -5px 0 0 $group6;
        }

        &.group7 {
            box-shadow: -5px 0 0 $group7;
        }

        &.group8 {
            box-shadow: -5px 0 0 $group8;
        }

        &.group9 {
            box-shadow: -5px 0 0 $group9;
        }
    }
</style>
